import { Product } from '@repo/shared-types';
import { Button } from '@repo/ui/components/button';
import { Image } from '@repo/ui/components/image';
import { formatCurrency } from '@repo/ui/lib/format/format-currency';
import { OptionsGrid } from './options-grid';

interface ProductSelectionStepProps {
  products: Product[];
  onSelectProduct: (productId: string) => void;
}

export function ProductSelectionStep({ products, onSelectProduct }: ProductSelectionStepProps) {
  if (products.length === 0) {
    return (
      <div className="flex flex-col gap-4 items-center justify-center py-8">
        <p className="text-gray-500 text-center">No hay productos disponibles en esta categoría</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 flex-1 min-h-0 overflow-y-auto">
      <OptionsGrid>
        {products.map((product) => {
          const hasImage =
            product.imageUrl !== null && product.imageUrl !== undefined && product.imageUrl !== '';

          if (hasImage) {
            return (
              <Button
                key={product.id}
                variant="pos-outline"
                onClick={() => onSelectProduct(product.id)}
              >
                <div className="flex flex-col h-full w-full">
                  <div className="h-[72%] w-full flex items-center justify-center overflow-hidden">
                    <Image
                      src={product.imageUrl}
                      alt={product.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="h-[28%] w-full flex flex-col items-center justify-center text-center gap-1">
                    <span className="text-lg font-medium truncate w-full">{product.name}</span>
                    <span className="text-sm text-neutral-500">
                      {formatCurrency(product.price)}
                    </span>
                  </div>
                </div>
              </Button>
            );
          }

          return (
            <Button
              key={product.id}
              variant="pos-outline"
              onClick={() => onSelectProduct(product.id)}
            >
              <div className="flex flex-col items-center justify-center gap-1">
                <div className="text-4xl! font-bold! text-center">{product.name}</div>
                <span className="text-sm text-neutral-500">{formatCurrency(product.price)}</span>
              </div>
            </Button>
          );
        })}
      </OptionsGrid>
    </div>
  );
}
